export interface Quality {
  id: string;
  key: string;
  description: string;
  groundEnds: number;
}
